import { CircularProgress } from 'libs/ui';

import { LoadingLayoutStyled } from './LoadingLayout.styles';

export const LoadingLayout = () => (
  <LoadingLayoutStyled alignItems="center" justifyContent="center">
    <CircularProgress color="success" size={40} />
  </LoadingLayoutStyled>
);
